// Global tooltip positioning system
document.addEventListener('DOMContentLoaded', function() {
  
  
  const tooltips = document.querySelectorAll('.help-tooltip');
  
  
  tooltips.forEach(function(helpTooltip, index) {
    
    
    const tooltipContent = helpTooltip.querySelector('.tooltip-content');
    if (!tooltipContent) {
      
      return;
    }
    
    
    
    let isTooltipVisible = false;
    
    // Find the containing section/element
    function findContainingSection() {
      let container = helpTooltip;
      while (container && container.parentElement) {
        container = container.parentElement;
        // Look for common section containers
        if (container.classList.contains('section-find-an-air-filter') ||
            container.classList.contains('product-main') ||
            container.classList.contains('product-info') ||
            container.classList.contains('container') ||
            container.tagName === 'SECTION') {
          return container;
        }
      }
      // Fallback to body if no container found
      return document.body;
    }
    
    function positionTooltip() {
      
      
      // Always make tooltip positioned (even when hidden) for measurement
      tooltipContent.style.opacity = isTooltipVisible ? '' : '0';
      tooltipContent.style.pointerEvents = isTooltipVisible ? '' : 'none';
      tooltipContent.classList.add('tooltip--visible');
      
      // Reset positioning classes and styles first
      tooltipContent.classList.remove('tooltip--bottom');
      tooltipContent.style.left = '';
      tooltipContent.style.bottom = '';
      tooltipContent.style.top = '';
      tooltipContent.style.transform = '';
      tooltipContent.style.setProperty('--arrow-offset', '50%');
      
      // Force a reflow to ensure styles are applied
      tooltipContent.offsetHeight;
      
      // Wait for next frame to ensure layout is complete
      requestAnimationFrame(function() {
        // Get the containing section
        const containingSection = findContainingSection();
        
        // Get positions after layout is complete
        const tooltipRect = tooltipContent.getBoundingClientRect();
        const buttonRect = helpTooltip.getBoundingClientRect();
        const containerRect = containingSection.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        
        // Get actual dimensions
        const tooltipWidth = tooltipRect.width;
        const tooltipHeight = tooltipRect.height;
        
        
        
        
        
        // Check if we need to show below instead of above based on space
        let showBelow = false;
        const spaceAbove = buttonRect.top;
        const spaceBelow = viewportHeight - buttonRect.bottom;
        
        
        
        if (spaceAbove < tooltipHeight + 20) {
          showBelow = true;
        }
        
        
        
        // Check if default centered position would overflow the containing section
        const buttonCenterX = buttonRect.left + (buttonRect.width / 2);
        const tooltipLeftEdge = buttonCenterX - (tooltipWidth / 2);
        const tooltipRightEdge = buttonCenterX + (tooltipWidth / 2);
        
        // Use container bounds with some padding
        const containerLeftEdge = containerRect.left + 10;
        const containerRightEdge = containerRect.right - 10;
        
        
        
        
        
        let offsetX = 0;
        
        // Check left edge against container
        if (tooltipLeftEdge < containerLeftEdge) {
          // Tooltip would go off left edge of container, shift it right
          offsetX = containerLeftEdge - tooltipLeftEdge;
          
        } 
        // Check right edge against container
        else if (tooltipRightEdge > containerRightEdge) {
          // Tooltip would go off right edge of container, shift it left
          offsetX = containerRightEdge - tooltipRightEdge;
          
        }
        
        // Apply positioning
        if (offsetX !== 0) {
          // Override the default centered position
          const pixelOffset = offsetX;
          tooltipContent.style.left = `calc(50% + ${pixelOffset}px)`;
          
          // Adjust arrow to still point to button center
          tooltipContent.style.setProperty('--arrow-offset', `calc(50% - ${pixelOffset}px)`);
          
        } else {
          // Use default centered position
          tooltipContent.style.left = '';
          tooltipContent.style.setProperty('--arrow-offset', '50%');
          
        }
        
        if (showBelow) {
          tooltipContent.classList.add('tooltip--bottom');
        }
        
        // Set final visibility state
        tooltipContent.style.opacity = isTooltipVisible ? '' : '0';
        tooltipContent.style.pointerEvents = isTooltipVisible ? '' : 'none';
        
        
      });
    }
    
    function showTooltip() {
      
      isTooltipVisible = true;
      positionTooltip();
    }
    
    function hideTooltip() {
      
      isTooltipVisible = false;
      // Keep positioned but make invisible
      tooltipContent.style.opacity = '0';
      tooltipContent.style.pointerEvents = 'none';
    }
    
    function toggleTooltip(e) {
      
      e.preventDefault();
      e.stopPropagation();
      
      if (isTooltipVisible) {
        hideTooltip();
      } else {
        showTooltip();
      }
    }
    
    // Position immediately on load
    positionTooltip();
    
    // Click to toggle
    helpTooltip.addEventListener('click', toggleTooltip);
    
    // Close tooltip when clicking outside
    document.addEventListener('click', function(e) {
      if (isTooltipVisible && !helpTooltip.contains(e.target)) {
        hideTooltip();
      }
    });
    
    // Always reposition on window resize (even when hidden)
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        
        positionTooltip();
      }, 100);
    });
    
    
  });
  
  
}); 